import React from 'react';
import './Footer.css'; 

const Footer = () => {
    return (
        <footer className="club-footer">
            <div className="footer-content">
                <p>© 2025 Bruin Linguists Society. All rights reserved.</p>
                <p>📍 UCLA, Los Angeles, CA | ✉️ <a href="mailto:bruinlinguists@gmail.com">bruinlinguists@gmail.com</a></p>
            </div>
        </footer>
    );
};

export default Footer;